<script lang="ts">
    
    import { gameClock } from "../../Services/game";


</script>

<div class="game-clock">
    <img src="/images/clock.svg" alt="">
    {$gameClock}
</div>

<style lang="scss">

    .game-clock {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 1.3rem;
    }

</style>
